import { $axios } from "@ocm/axios";
import type { CountryCodeLowerCase } from "@ocm/global-types";

export type RecommendationData = typeof window.recommendationData;

export type AxiosConfig = {
	data: unknown;
	headers?: {
		lastPlsPage: string;
	};
	method: string;
	params: string;
	url: string;
};

export const fetchRecommendationData = async (url: string, axiosConfig?: AxiosConfig) => {
	const path = getUrlWithoutContext(url);

	const { data }: { data: RecommendationData } = await $axios({
		url: "/rest/data-layer",
		params: { path },
		...axiosConfig,
	});

	setRecommendationData(data);
	updateDataLayerRecommendationForTheTool(data);
	return data;
};

const getUrlWithoutContext = (url: string) => {
	let path: URL;
	if (url.startsWith("https://") || url.startsWith("http://")) {
		path = new URL(url);
	} else {
		path = new URL(url, window.location.origin);
	}
	return path.pathname.replace(window.currentContextPath, "");
};

const setRecommendationData = (data: RecommendationData) => {
	window.recommendationData = data; // used by epoq and more
};

const updateDataLayerRecommendationForTheTool = (data: RecommendationData) => {
	window.dataLayer[0] = data;
};

export const getCustomerData = () => window.recommendationData.Recommendation.customerData;
export const getDeliveryCountry = () =>
	(getCustomerData().deliveryCountry ?? "DE").toLowerCase() as CountryCodeLowerCase;

export const getPageData = () => window.recommendationData.Recommendation.pageData;
export const getPageType = () => getPageData()?.pageType ?? "";
export const getPagePath = () => getPageData()?.pagePath ?? "";

export const getProductData = () => window.recommendationData.Recommendation.productData;

export const initAndGetRecommendationData = async (): Promise<RecommendationData> => {
	try {
		await fetchRecommendationData("/cart");
	} catch (error) {
		(error as Error).message && console.error((error as Error).message);
	}
	return {
		Recommendation: window.dataLayer[0]?.Recommendation,
	};
};

export const getExistingRecommendation = (): RecommendationData["Recommendation"] | undefined => {
	window.dataLayer = window.dataLayer || [];
	return window.dataLayer.find((entry) => entry?.Recommendation)?.Recommendation;
};
